import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import CircularProgress from '@material-ui/core/CircularProgress'
import Checkbox from '@material-ui/core/Checkbox'
import { IconButton, FormControlLabel } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { AuthContext } from '../../../../../auth-context'
import { setStripeKey, disableStripe, getStripeStoreData, addStripeLandingPage, updateStripeLandingPage, deleteStripeLandingPage } from '../../../../../api'
import { DashboardContext } from '../../../dashboard-context'
import config from '../../../../../config'

const WhiteCheckbox = withStyles({
  root: {
    color: "#070c29",
    "&$checked": {
      color: "#070c29",
    },
  },
  checked: {},
})((props) => <Checkbox {...props} />)

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Info = styled.div`
  margin-bottom: 24px;

  p {
    color: #5a5a5a;
    font-size: 1rem;
  }

  span {
    font-family: ${props => props.theme.font.primary};
    font-size: 1.25rem;
    font-weight: 500;
  }
`;

const TableTitle = styled.h2`
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`;

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  margin: 0 auto;
`;

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`;

const TableHead = styled.thead`
  color: #FFF;
`;

const TableBody = styled.tbody`
`;

const TableHeadRow = styled.tr`
`;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: 100px;
  padding: 8px;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: 'DM Sans', sans-serif;
  padding: 4px;
  text-align: center;
`;

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: .875rem;
  padding: 4px;
`;

const ProductList = styled.ul`
  list-style-type: none;
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
  min-width: 180px;
`

const Instructions = styled.p`
  margin-bottom: 20px;
`

const StripeInfo = (props) => {
  const { openSnackbar } = useContext(DashboardContext)
  const { user, updateUser } = useContext(AuthContext)
  const [key, updateKey] = useState(user.stripe_data === null ? '' : user.stripe_data.key)
  const [editingKey, updateEditingKey] = useState(false)
  const [disabling, updateDisabling] = useState(false)
  const [keyError, updateKeyError] = useState(false)
  const [managingStore, updateManagingStore] = useState(false)
  const [storeDataState, updateStoreDataState] = useState(0)
  const [storeData, updateStoreData] = useState(null)
  const [editingLandingPageId, updateEditingLandingPageId] = useState(null)
  const [landingPageName, updateLandingPageName] = useState(null)
  const [landingPageEnabled, updateLandingPageEnabled] = useState(null)
  const [landingPagePrices, updateLandingPagePrices] = useState({})
  const [nameError, updateNameError] = useState(false)
  const [deletingLandingPageIndex, updateDeletingLandingPageIndex] = useState(null)

  let editingLandingPageIndex = null
  let editingLandingPageTitle = null
  let editingLandingPageName = null
  let editingLandingPageEnabled = null
  let editingLandingPagePrices = {}
  if (editingLandingPageId !== null) {
    if (editingLandingPageId === 0) {
      editingLandingPageTitle = 'Add Landing Page'
      editingLandingPageName = ''
      editingLandingPageEnabled = true
      for (const priceId in storeData.prices) {
        editingLandingPagePrices[priceId] = false
      }
      if (landingPageName !== null) {
        editingLandingPageName = landingPageName
      }
      if (landingPageEnabled !== null) {
        editingLandingPageEnabled = landingPageEnabled
      }
      for (const priceId in landingPagePrices) {
        editingLandingPagePrices[priceId] = landingPagePrices[priceId]
      }
    } else {
      editingLandingPageTitle = 'Update Landing Page'
      if (storeDataState === 2) {
        for (let n = 0; n < storeData.landing_pages.length; ++n) {
          if (storeData.landing_pages[n].id === editingLandingPageId) {
            editingLandingPageIndex = n
            editingLandingPageName = storeData.landing_pages[n].name
            editingLandingPageEnabled = storeData.landing_pages[n].enabled !== 0
            for (const priceId in storeData.prices) {
              editingLandingPagePrices[priceId] = false
            }
            storeData.landing_pages[n].data.prices.forEach((p) => {
              editingLandingPagePrices[p] = true
            })
            if (landingPageName !== null) {
              editingLandingPageName = landingPageName
            }
            if (landingPageEnabled !== null) {
              editingLandingPageEnabled = landingPageEnabled
            }
            for (const priceId in landingPagePrices) {
              editingLandingPagePrices[priceId] = landingPagePrices[priceId]
            }
            break
          }
        }
      }
    }
  }

  const handleBeginEditingKey = () => {
    updateEditingKey(true)
  }

  const handleSetKey = () => {
    if (key === '') {
      openSnackbar('Please enter your Stripe live API secret key.', true)
      updateKeyError(true)
    } else if (key.indexOf('pk_') === 0) {
      openSnackbar('A publishable API key is not valid here. Please enter your live API secret key.', true)
      updateKeyError(true)
    } else if (key.indexOf('sk_live_') !== 0 && key.indexOf('sk_test_') !== 0 && key.indexOf('rk_live_') !== 0) {
      openSnackbar('Please enter your live API secret key, which should begin with "sk_live_".', true)
      updateKeyError(true)
    } else {
      setStripeKey(user.id, key).then(() => {
        openSnackbar('Your secret key was successfully ' + (user.stripe_data === null ? 'set.' : 'updated.'), false)
        updateUser(Object.assign({}, user, { stripe_data: user.stripe_data === null ? { key: key } : Object.assign({}, user.stripe_data, { key: key }) }))
        updateEditingKey(false)
        updateKeyError(false)
      }).catch((err) => {
        let message = 'There was a problem setting your secret key.'
        if (err.response) {
          if (err.response.data) {
            if (err.response.data.error) {
              message = err.response.data.error
            }
          }
        }
        openSnackbar(message, true)
      })
    }
  }

  const handleCancelEditingKey = () => {
    updateKey(user.stripe_data === null ? '' : user.stripe_data.key)
    updateEditingKey(false)
    updateKeyError(false)
  }

  const handleBeginDisabling = () => {
    updateDisabling(true)
  }

  const handleDisableStripe = () => {
    disableStripe(user.id).then(() => {
      openSnackbar('Your Stripe Billing has been successfully disabled.', false)
      updateUser(Object.assign({}, user, { stripe_data: null }))
      updateKey('')
      updateDisabling(false)
    }).catch((err) => {
      console.log('handleDisableStripe err')
      console.log(err)
      openSnackbar('There was a problem disabling your Stripe billing.', true)
    })
  }

  const handleCancelDisable = () => {
    updateDisabling(false)
  }

  const handleBeginManagingStore = () => {
    updateManagingStore(true)
    if (storeDataState === 0) {
      updateStoreDataState(1)
      getStripeStoreData(user.id).then((res) => {
        updateStoreData(res.data)
        updateStoreDataState(2)
      }).catch((err) => {
        let message = 'There was a problem getting store data.'
        if (err.response) {
          if (err.response.data) {
            if (err.response.data.error) {
              message = err.response.data.error
            }
          }
        }
        openSnackbar(message, true)
        updateStoreDataState(0)
        updateManagingStore(false)
      })
    }
  }

  const handleAddLandingPage = () => {
    updateEditingLandingPageId(0)
  }

  const handleEditLandingPage = (id) => {
    updateEditingLandingPageId(id)
  }

  const handleToggleLandingPageEnabled = () => {
    updateLandingPageEnabled(!editingLandingPageEnabled)
  }

  const handleToggleLandingPagePrice = (priceId) => {
    let newLandingPagePrices = Object.assign({}, editingLandingPagePrices)
    newLandingPagePrices[priceId] = !editingLandingPagePrices[priceId]
    updateLandingPagePrices(newLandingPagePrices)
  }

  const handleRefreshProducts = () => {
    if (storeDataState === 2) {
      updateStoreDataState(1)
      getStripeStoreData(user.id).then((res) => {
        updateStoreData(res.data)
        updateStoreDataState(2)
      }).catch((err) => {
        let message = 'There was a problem getting store data.'
        if (err.response) {
          if (err.response.data) {
            if (err.response.data.error) {
              message = err.response.data.error
            }
          }
        }
        openSnackbar(message, true)
        updateStoreDataState(0)
        updateEditingLandingPageId(null)
        updateLandingPageName(null)
        updateLandingPageEnabled(null)
        updateLandingPagePrices({})
        updateNameError(false)
        updateManagingStore(false)
      })
    }
  }

  const handleDeleteLandingPage = (lpi) => {
    updateDeletingLandingPageIndex(lpi)
  }

  const handleCancelEditingLandingPage = () => {
    updateEditingLandingPageId(null)
    updateLandingPageName(null)
    updateLandingPageEnabled(null)
    updateLandingPagePrices({})
    updateNameError(false)
  }

  const sortByName = (a, b) => {
    const aLower = a.name.toLowerCase()
    const bLower = b.name.toLowerCase()
    return aLower < bLower ? -1 : (aLower > bLower ? 1 : 0)
  }

  const handleSaveLandingPage = () => {
    if (storeDataState === 2 && editingLandingPageEnabled !== null) {
      const name = editingLandingPageName.trim()
      if (name === '') {
        openSnackbar('Please enter a name for this landing page.', true)
        updateNameError(true)
      } else {
        const lowerName = name.toLowerCase()
        let duplicate = false
        for (let n = 0; n < storeData.landing_pages.length; ++n) {
          if (n !== editingLandingPageIndex && lowerName === storeData.landing_pages[n].name.toLowerCase()) {
            duplicate = true
            break
          }
        }
        if (duplicate) {
          openSnackbar('Another landing page has the same name.', true)
          updateNameError(true)
        } else {
          const enabled = editingLandingPageEnabled ? 1 : 0
          let prices = []
          for (const priceId in storeData.prices) {
            if (editingLandingPagePrices[priceId]) {
              prices.push(priceId)
            }
          }
          if (prices.length === 0) {
            openSnackbar('Please include at least one product.', true)
            updateNameError(true)
          } else if (editingLandingPageId === 0) {
            addStripeLandingPage(user.id, name, enabled, prices).then((res) => {
              openSnackbar('The landing page was successfully added.', false)
              let newLandingPages = storeData.landing_pages.slice(0)
              newLandingPages.push({ id: res.data.id, name: name, enabled: enabled, data: { prices } })
              newLandingPages.sort(sortByName)
              updateStoreData(Object.assign({}, storeData, { landing_pages: newLandingPages }))
              updateEditingLandingPageId(null)
              updateLandingPageName(null)
              updateLandingPageEnabled(null)
              updateLandingPagePrices({})
              updateNameError(false)
            }).catch((err) => {
              console.log('handleSaveLandingPage add err')
              console.log(err)
              openSnackbar('There was a problem adding the landing page.', true)
            })
          } else {
            updateStripeLandingPage(user.id, editingLandingPageId, name, enabled, prices).then((res) => {
              openSnackbar('The landing page was successfully updated.', false)
              let newLandingPages = storeData.landing_pages.map((lp) => lp.id !== editingLandingPageId ? lp : { id: editingLandingPageId, name: name, enabled: enabled, data: { prices } }).sort(sortByName)
              updateStoreData(Object.assign({}, storeData, { landing_pages: newLandingPages }))
              updateEditingLandingPageId(null)
              updateLandingPageName(null)
              updateLandingPageEnabled(null)
              updateLandingPagePrices({})
              updateNameError(false)
            }).catch((err) => {
              console.log('handleSaveLandingPage update err')
              console.log(err)
              openSnackbar('There was a problem updating the landing page.', true)
            })
          }
        }
      }
    }
  }

  const handleDoDeleteLandingPage = () => {
    deleteStripeLandingPage(user.id, storeData.landing_pages[deletingLandingPageIndex].id).then((res) => {
      openSnackbar('The landing page was successfully deleted.', false)
      let newLandingPages = storeData.landing_pages.slice(0)
      newLandingPages.splice(deletingLandingPageIndex, 1)
      updateStoreData(Object.assign({}, storeData, { landing_pages: newLandingPages }))
      updateDeletingLandingPageIndex(null)
    }).catch((err) => {
      console.log('handleDoDeleteLandingPage err')
      console.log(err)
      openSnackbar('There was a problem deleting the landing page.', true)
    })
  }

  const handleCancelDeletingLandingPage = () => {
    updateDeletingLandingPageIndex(null)
  }

  const handleDoneManagingStore = () => {
    updateManagingStore(false)
  }

  const getPriceDescription = (priceId) => {
    let result = '(deleted)'
    if (priceId in storeData.prices) {
      const price = storeData.prices[priceId]
      const product = storeData.products[price.product_id]
      result = product.name + ' for $' + (price.unit_amount / 100).toFixed(2) + (price.recurring === null ? '' : (' per ' + price.recurring.interval))
    }
    return result
  }

  const getLandingPageUrl = (id) => {
    return config.API_ROOT + '/portal-landing/' + user.id + '/' + id
  }

  const getLandingPageLink = (id) => {
    const url = getLandingPageUrl(id)
    return (
      <a href={url}>{url}</a>
    )
  }
  
  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <MonetizationOnIcon /> Stripe Billing
        </Label>
        {editingLandingPageId !== null ? (
          <>
            <TableTitle>{editingLandingPageTitle}</TableTitle>
            {storeDataState !== 2 ? (
              <CircularProgress size={32} />
            ) : (storeData.prices.length === 0 ? (
              <p>You have no active products in your Stripe account. Please <a href="https://dashboard.stripe.com/products?active=true">add a product</a>, and then click "Refresh Products" below.</p>
            ) : (editingLandingPageEnabled !== null &&
              <>
                <Instructions>Please note: if your clients purchase subscriptions, you will need to manage those subscriptions from your Stripe account.</Instructions>
                <Input
                  error={nameError}
                  label="Landing Page Name (for internal use)"
                  value={editingLandingPageName}
                  onChange={updateLandingPageName}
                />
                <FormControlLabel
                  control={
                    <WhiteCheckbox
                      checked={editingLandingPageEnabled}
                      onChange={handleToggleLandingPageEnabled}
                      inputProps={{ "aria-label": "checkbox" }}
                    />
                  }
                  label="Enabled"
                />
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableHeadRow>
                        <HeadCell>Included</HeadCell>
                        <HeadCell>Product</HeadCell>
                      </TableHeadRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(storeData.prices).map((p, pi) => 
                        <TableBodyRow key={pi}>
                          <DataCell>
                            <WhiteCheckbox
                              checked={editingLandingPagePrices[p]}
                              onChange={() => handleToggleLandingPagePrice(p)}
                              inputProps={{ "aria-label": "checkbox" }}
                            />
                          </DataCell>
                          <DataCell>{getPriceDescription(p)}</DataCell>
                        </TableBodyRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            ))}
            <ButtonContainer>
              <AddButton
                label="Refresh Products"
                onClick={handleRefreshProducts}
              />
              <AddButton
                label="Save"
                onClick={handleSaveLandingPage}
              />
              <AddButton
                label={'Cancel ' + (editingLandingPageId === 0 ? 'Add' : 'Update') + ' Landing Page'}
                onClick={handleCancelEditingLandingPage}
              />
            </ButtonContainer>
          </>
        ) : (deletingLandingPageIndex !== null ? (
          <>
            <Info>
              <p>Are you sure you want to delete this landing page?</p>
            </Info>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableHeadRow>
                    <HeadCell>Name</HeadCell>
                    <HeadCell>Choices</HeadCell>
                    <HeadCell>URL</HeadCell>
                  </TableHeadRow>
                </TableHead>
                <TableBody>
                  <TableBodyRow>
                    <DataCell>{storeData.landing_pages[deletingLandingPageIndex].name}</DataCell>
                    <DataCell>
                      <ProductList>
                        {storeData.landing_pages[deletingLandingPageIndex].data.prices.map((p, pi) =>
                          <li key={pi}>{getPriceDescription(p)}</li>
                        )}
                      </ProductList>
                    </DataCell>
                    <DataCell>{storeData.landing_pages[deletingLandingPageIndex].enabled ? getLandingPageLink(storeData.landing_pages[deletingLandingPageIndex].id) : '(disabled)'}</DataCell>
                  </TableBodyRow>
                </TableBody>
              </Table>
            </TableContainer>
            <ButtonContainer>
              <AddButton
                label="Delete Landing Page"
                onClick={handleDoDeleteLandingPage}
              />
              <AddButton
                label="Cancel Delete"
                onClick={handleCancelDeletingLandingPage}
              />
            </ButtonContainer>
          </>
        ) : (managingStore ? (
          <>
            <TableTitle>Landing Pages</TableTitle>
            {storeDataState !== 2 ? (
              <CircularProgress size={32} />
            ) : (storeData.landing_pages.length === 0 ? (
              <p>You have no landing pages yet. Click "Add Landing Page" below.</p>
            ) : (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableHeadRow>
                      <HeadCell>Name</HeadCell>
                      <HeadCell>Choices</HeadCell>
                      <HeadCell>URL</HeadCell>
                      <HeadCell>Actions</HeadCell>
                    </TableHeadRow>
                  </TableHead>
                  <TableBody>
                    {storeData.landing_pages.map((lp, lpi) => 
                      <TableBodyRow key={lpi}>
                        <DataCell>{lp.name}</DataCell>
                        <DataCell>
                          <ProductList>
                            {lp.data.prices.map((p, pi) =>
                              <li key={pi}>{getPriceDescription(p)}</li>
                            )}
                          </ProductList>
                        </DataCell>
                        <DataCell>{lp.enabled ? getLandingPageLink(lp.id) : '(disabled)'}</DataCell>
                        <ButtonCell>
                          <IconButton onClick={() => handleEditLandingPage(lp.id)}><EditIcon /></IconButton>
                          <IconButton onClick={() => handleDeleteLandingPage(lpi)}><DeleteIcon /></IconButton>
                        </ButtonCell>
                      </TableBodyRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            ))}
            <ButtonContainer>
              <AddButton
                label="Add Landing Page"
                onClick={handleAddLandingPage}
              />
              <AddButton
                label="Done"
                onClick={handleDoneManagingStore}
              />
            </ButtonContainer>
          </>
        ) : (editingKey ? (
          <>
            <Input
              error={keyError}
              label="Stripe Live API Secret Key"
              value={key}
              onChange={updateKey}
            />
            <ButtonContainer>
              <AddButton
                label={user.stripe_data === null ? 'Set Key' : 'Update Key'}
                onClick={handleSetKey}
              />
              <AddButton
                label={user.stripe_data === null ? 'Cancel Set Key' : 'Cancel View/Update Key'}
                onClick={handleCancelEditingKey}
              />
            </ButtonContainer>
          </>
        ) : (disabling ? (
          <>
            <Info>
              <p>Are you sure you want to disable Stripe Billing?</p>
            </Info>
            <ButtonContainer>
              <AddButton
                label="Disable Stripe Billing"
                onClick={handleDisableStripe}
              />
              <AddButton
                label="Cancel Disable"
                onClick={handleCancelDisable}
              />
            </ButtonContainer>
          </>
        ) : (user.stripe_data === null ? (
          <>
            <Info>
              <p>You can use Stripe Billing to let clients easily purchase your products and services.</p>
              <p>Stripe Billing is not currently enabled for your account.</p>
              <p>The cost for Stripe Billing is $10 per month, plus an additional $1 per month for each client.</p>
              <p>To enable Stripe Billing, first <a href="https://dashboard.stripe.com/register">create a Stripe account</a> if you have not done so already. Then <a href="https://stripe.com/docs/keys">look up</a> your live API secret key, and click "Set Secret Key" below.</p>
            </Info>
            <ButtonContainer>
              <AddButton
                label="Set Secret Key"
                onClick={handleBeginEditingKey}
              />
            </ButtonContainer>
          </>
        ) : (
          <>
            <Info>
              <p>Stripe Billing is currently enabled for your account.</p>
            </Info>
            <ButtonContainer>
              <AddButton
                label="Manage Landing Pages"
                onClick={handleBeginManagingStore}
              />
              <AddButton
                label="View/Update Secret Key"
                onClick={handleBeginEditingKey}
              />
              <AddButton
                label="Disable Stripe Billing"
                onClick={handleBeginDisabling}
              />
            </ButtonContainer>
          </>
        ))))))}
      </Container>
    </React.Fragment>
  )
}

export default StripeInfo